import { render, staticRenderFns } from "./xcSetup-znzd.vue?vue&type=template&id=345b25bc&scoped=true&"
import script from "./xcSetup-znzd.vue?vue&type=script&lang=js&"
export * from "./xcSetup-znzd.vue?vue&type=script&lang=js&"
import style0 from "./xcSetup-znzd.vue?vue&type=style&index=0&id=345b25bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345b25bc",
  null
  
)

export default component.exports